export default __webpack_public_path__ + "static/media/wellgo_reviewer.2da10eef.jpg";